<template>
  <MasterLayout>
    <div class="new-staff">
      <div class="add_new_bank_account_header">
        <p>
          {{ mode == "create" ? "Create branch space" : "Edit Branch space " }}
        </p>
      </div>
      <div class="cover">
        <div class="personal">
          <div class="row">
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.bLease.propertyName") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="text"
                  :placeholder="$t('text.bLease.propertyName')"
                  v-model="formData.propertyName"
                  class="border-0"
                />
              </div>
            </div>

            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel"> {{ $t("text.bLease.rentFee") }} </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="number"
                  :placeholder="$t('text.bLease.rentFee')"
                  v-model="formData.rentFee"
                  class="border-0"
                />
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel"> {{ $t("text.bLease.noRooms") }} </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="number"
                  :placeholder="$t('text.bLease.rooms')"
                  v-model="formData.numberOfRooms"
                  class="border-0"
                />
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.bLease.noRestRoom") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="number"
                  :placeholder="$t('text.bLease.restRoom')"
                  v-model="formData.numberOfRestRooms"
                  class="border-0"
                />
              </div>
            </div>

            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel"> {{ $t("text.bLease.restRoom") }} </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="text"
                  :placeholder="$t('text.bLease.rentDuration')"
                  v-model="formData.rentDuration"
                  class="border-0"
                />
              </div>
            </div>
          </div>
          <div class="personal mt-4 w-100">
            <div class="row">
              <div class="input__group__block mt-4 col-md-12">
                <label class="required">
                  <span class="mylabel">
                    {{ $t("text.bLease.propDesc") }}
                  </span>
                </label>
                <div class="price_change_input_wrapper">
                  <textarea
                    :placeholder="$t('text.bLease.propDesc')"
                    v-model="formData.propertyDescription"
                    class="border-0"
                  >
                  </textarea>
                </div>
              </div>
              <div class="input__group__block mt-4 col-md-12">
                <label class="required">
                  <span class="mylabel"> {{ $t("text.bLease.addSet") }} </span>
                </label>
                <div class="price_change_input_wrapper">
                  <textarea
                    :placeholder="$t('text.bLease.addSet')"
                    v-model="formData.additionalDetails"
                    class="border-0"
                  >
                  </textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center mt-4 pb-4">
            <button
              :disabled="isButtonDisabled ? true : false"
              class="ep-btn ep-primary"
              @click="
                mode === 'create'
                  ? createBranchSpace($event)
                  : updateSpace($event)
              "
            >
              {{ mode == "create" ? "Create" : "Update" }}
            </button>
            <img
              src="@/assets/img/git_loader.gif"
              style="display: none"
              width="35px"
              class="ml-3 loader"
            />
          </div>
        </div>
      </div>
    </div>
  </MasterLayout>
</template>

<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import configObject from "@/config";
import backgroundUrl from "@/assets/img/retain.jpg";
import VueTagsInput from "@johmun/vue-tags-input";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Create branch space :: Epump Portal",
  name: "CreateBranchStaff",
  components: {
    MasterLayout,
    VueTagsInput,
    PulseLoader,
  },
  data() {
    return {
      branch: "",
      formData: {
        propertyName: "",
        numberOfRooms: 0,
        numberOfRestRooms: 0,
        propertyDescription: "",
        additionalDetails: "",
      },
      rentDurations: [
        {
          name: "Yearly",
          durationPrice: 1,
        },
      ],
      tenures: [
        {
          value: "Yearly",
          name: "Yearly",
          disabled: false,
        },
        {
          value: "Monthly",
          name: "Monthly",
          disabled: false,
        },
        {
          value: "Weekly",
          name: "Weekly",
          disabled: false,
        },
        {
          value: "Daily",
          name: "Daily",
          disabled: false,
        },
      ],
      branchSpaces: [],
      branchSpace: "",
      mode: "create",
      isButtonDisabled: false,
      fields: [
        {
          key: "name",
          label: "Name",
          class: "text-center",
        },
        { key: "durationPrice", label: "Price", class: "text-center" },
        { key: "action", label: "Action", class: "text-center" },
      ],
    };
  },
  computed: {
    clonedItems: function () {
      return JSON.parse(JSON.stringify(this.rentDurations));
    },
  },
  watch: {
    clonedItems(newDurations, oldDurations) {
      if (newDurations.length !== oldDurations.length) {
        this.tenures.forEach((el) => {
          el.disabled = false;
        });
        this.rentDurations.forEach((el) => {
          const tenureIndex = this.tenures.findIndex(
            (tenure) => tenure.name === el.name
          );
          if (tenureIndex > -1) {
            this.tenures[tenureIndex].disabled = true;
          }
        });
      }
    },
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
        }
      }
    },
  },
  created() {
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Create Branch space :: ${branch.name} Retail Outlet`;
    });
  },
  mounted() {
    if (this.$route.query.spaceId) {
      this.mode = "edit";
      this.getBranchSpace();
    }
  },
  beforeDestroy() {},
  methods: {
    addRentDuration() {
      this.rentDurations.push({
        name: "",
        durationPrice: 1,
      });
    },
    removeRentDuration(index) {
      this.rentDurations.splice(index, 1);
    },
    getBranchSpace() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/BranchSpace/Get/All/${this.branch.id}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.forEach((el) => {
            el.text = el.name;
            el.value = el.id;
          });
          this.branchSpaces = response.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    createBranchSpace($event) {
      $event.preventDefault();

      if (!this.formData.propertyName) {
        this.$toast.open({
          message: this.$t("text.bLease.propNameReq"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.formData.numberOfRooms) {
        this.$toast.open({
          message: this.$t("text.bLease.noRoomReq"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.formData.numberOfRestRooms) {
        this.$toast.open({
          message: this.$t("text.bLease.noRestroomReq"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.formData.propertyDescription) {
        this.$toast.open({
          message: this.$t("text.bLease.propDescReq"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.formData.additionalDetails) {
        this.$toast.open({
          message: this.$t("text.bLease.addDetReq"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      let data = {
        branchId: this.branch.id,
        propertyName: this.formData.propertyName,
        propertyDescription: this.formData.propertyDescription,
        numberOfRooms: Number(this.formData.numberOfRooms),
        numberOfRestRooms: Number(this.formData.numberOfRestRooms),
        additionalDetails: this.formData.additionalDetails,
        rentDurations: this.rentDurations,
      };

      for (const field of this.rentDurations) {
        field.durationPrice = Number(field.durationPrice);
        if (!field.name || !field.durationPrice) {
          this.$toast.open({
            message: this.$t("text.bLease.allMissingData"),
            type: "error",
            duration: 5000,
          });
          return;
        }
      }
      // console.log(data);

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/BranchSpace/Post`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$router.push({
            name: "BranchSpace",
            query: {
              companyId: this.$route.query.companyId
                ? this.$route.query.companyId
                : this.branch.companyId,
              branchId: this.$route.query.branchId
                ? this.$route.query.branchId
                : this.branch.id,
              dealerId: this.$route.query.dealerId,
              groupId: this.$route.query.groupId,
              regionId: this.$route.query.regionId,
            },
          });
          this.$toast.open({
            message: this.$t("text.bLease.successfullyCreatedBS"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    updateSpace($event) {
      $event.preventDefault();
      if (!this.formData.propertyName) {
        this.$toast.open({
          message: this.$t("text.bLease.propNameReq"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.formData.propertyDescription) {
        this.$toast.open({
          message: this.$t("text.bLease.propDescReq"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.formData.numberOfRooms) {
        this.$toast.open({
          message: this.$t("text.bLease.noRoomReq"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.formData.numberOfRestRooms) {
        this.$toast.open({
          message: this.$t("text.bLease.noRestroomReq"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      if (!this.formData.additionalDetails) {
        this.$toast.open({
          message: this.$t("text.bLease.addDetReq"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      let data = {
        propertyName: this.formData.propertyName,
        propertyDescription: this.formData.propertyDescription,
        numberOfRooms: Number(this.formData.numberOfRooms),
        numberOfRestRooms: Number(this.formData.numberOfRestRooms),
        additionalDetails: this.formData.additionalDetails,
      };

      this.isButtonDisabled = true;
      $(".loader").show();

      this.axios
        .put(
          `${configObject.apiBaseUrl}/BranchSpace/Edit/${this.$route.query.spaceId}`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$router.push({
            name: "BranchSpace",
            query: {
              companyId: this.$route.query.companyId
                ? this.$route.query.companyId
                : this.branch.companyId,
              branchId: this.$route.query.branchId
                ? this.$route.query.branchId
                : this.branch.id,
              dealerId: this.$route.query.dealerId,
              groupId: this.$route.query.groupId,
              regionId: this.$route.query.regionId,
            },
          });

          this.$toast.open({
            message: this.$t("text.bLease.successfullyUpdatedBS"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    getBranchSpace() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/BranchSpace/Get/${this.$route.query.spaceId}`,
          configObject.authConfig()
        )
        .then((response) => {
          console.log(response.data);
          this.formData = response.data;
          this.formData.propertyName = response.data.name;
          this.formData.propertyDescription = response.data.description;
          this.formData.numberOfRooms = response.data.rooms;
          this.formData.numberOfRestRooms = response.data.restrooms;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>
